/*
 * @Author: songyzh
 * @Date: 2020-08-18 17:16:05
 * @LastEditors: songyzh
 * @LastEditTime: 2021-01-15 09:33:55
 */
import axios from 'axios';
import iview from 'view-design';

export default class HttpRequest {
  constructor({ BASEURL, TIMEOUT = 60000 * 3, errorHook = () => {} }) {
    this.config = {
      baseURL: BASEURL,
      timeout: TIMEOUT,
      withCredentials: true
    };
    this.instance = axios.create(this.config);
    // 请求错误钩子，可以在外面注册错误回调处理
    this.errorHook = errorHook;
    // 安装拦截器
    this.interceptors();
    return this.instance;
  }

  // 拦截器
  interceptors(instance = this.instance) {
    // 请求拦截
    instance.interceptors.request.use(
      config => config,
      error => Promise.reject(error) // 请求失败
    );
    // 响应拦截
    instance.interceptors.response.use(
      response => {
        const { status, config, message } = response;
        const { code } = response;
        let { showErrorMessage } = config;
        // showErrorMessage 不传，默认展示错误信息
        if (showErrorMessage === undefined) {
          showErrorMessage = true;
        }
        if (status === 200 || code === 0) {
          const { data } = response;
          return Promise.resolve(data);
        }
        this.errorHook(response);
        return showErrorMessage && iview.Message.error(message);
      },
      error => {
        debugger;
        this.errorHook(error.response);
        iview.Message.error(error.response.data.message || error.message);
        return Promise.reject(error.response);
      }
    );
  }

  static get(...args) {
    return axios.get(...args);
  }
}
